import ActionTypes from 'core/actions/actionTypes';

export const updatePageSize = (payload) => {
    return {
        type: ActionTypes.UPDATE_ITEMS_TO_SHOW,
        payload: payload
    }
}




// WEBPACK FOOTER //
// ./src/core/actions/pageSizeActions.ts